import I18n from 'i18n-js';
import React, { Component } from 'react';
import { array, func, shape } from 'prop-types';
import { connect } from 'react-redux';
import { parse } from 'qs';
import { getMembersFromService } from '../../members/actions/members';
import { retrieveService } from '../../services/actions/services';
import Autocomplete from '../../common/components/Autocomplete';
import ServiceSearchResults from '../components/ServiceSearchResults';

class SearchService extends Component {
  static propTypes = {
    servicesList: array.isRequired,
    selectedService: shape().isRequired,
    getMembersFromService: func.isRequired,
    retrieveService: func.isRequired,
    history: shape().isRequired,
    location: shape().isRequired,
  };

  constructor(props) {
    super(props);

    const query = parse(props.location.search.substr(1));
    const { q } = query;

    this.state = {
      queryUrl: q || '',
    };

    this.onSelectItem = this.onSelectItem.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  componentDidMount() {
    const { history, selectedService } = this.props;

    if (selectedService.service) {
      const { name } = selectedService.service;

      this.setState({ queryUrl: name });
      history.push(`?q=${name.replace(' ', '+').toLowerCase()}`);
    }
  }

  /**
   * {@inheritdoc}
   */
  componentDidUpdate(prevProps) {
    const { servicesList, retrieveService } = this.props;
    const { queryUrl } = this.state;

    if (prevProps.servicesList === servicesList) {
      return;
    }

    if (queryUrl.length) {
      retrieveService(queryUrl);
    }
  }

  /**
   * @param {Object} item
   */
  onSelectItem(item) {
    const queryPath = item.name.replace(' ', '+').toLowerCase();

    this.setState({ queryUrl: item.name });

    this.props.history.push(`?q=${queryPath}`);
    this.props.getMembersFromService(item);
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { selectedService, servicesList } = this.props;
    const { queryUrl } = this.state;

    return (
      <div className="container search-service">
        <h1>{I18n.t('pages.services.title')}</h1>
        <Autocomplete
          items={this.props.servicesList}
          getItemValue={item => item.name}
          onSelectItem={this.onSelectItem}
          defaultValue={queryUrl}
          placeholder={I18n.t('pages.services.search:placeholder')}
        />
        <ServiceSearchResults
          servicesList={servicesList}
          selectedService={selectedService}
          fallbackService={this.onSelectItem}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  servicesList: state.services.list,
  selectedService: state.selectedService,
});

const mapDispatchToProps = dispatch => ({
  getMembersFromService: service => dispatch(getMembersFromService(service)),
  retrieveService: name => dispatch(retrieveService(name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchService);



// WEBPACK FOOTER //
// ./src/modules/services/containers/SearchService.js